module.exports = {
      id: "icon-clinic-response-usage",
      viewBox: "0 0 18 17",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-clinic-response",
      toString: function () {
        return this.url;
      }
    }